import PropTypes from 'prop-types';
import {
	compose,
	getContext,
	withProps
} from 'recompose';

import CustomOverlayComponent from './customOverlayComponent';

export const enhance = compose(
	getContext({
		disableIdleEvent: PropTypes.func
	}),
	withProps((props) => ({
		animationDelay: 250,
		className: 'info-window',
		appendToMap: false,
		gesturesDisabled: false,
	}))
);

export default enhance(CustomOverlayComponent);
